import { ReactElement, useState } from 'react'
import { useSelector } from 'react-redux'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import { Stack } from '@mui/material'
import { RootState } from 'store'
import { Input, Modal, ModalColumnHeading } from 'components'
import * as sxStyles from './userInfoModal.style'

interface Props {}

const useUserInfoModal = ({}: Props): [ReactElement, VoidFunction] => {
  const user = useSelector((state: RootState) => state.user.profile)

  const [isOpen, setIsOpen] = useState<boolean>(false)

  const toggleModal = () => setIsOpen(!isOpen)

  return [
    <Modal
      isOpen={isOpen}
      onClose={toggleModal}
      onConfirm={toggleModal}
      title="User Info"
      hideConfirmButton={true}
    >
      <Box px="24px" py="20px" sx={sxStyles.mainBox}>
        <Box sx={sxStyles.modalColumnHeadingBox}>
          <ModalColumnHeading>Details</ModalColumnHeading>
          <Stack sx={sxStyles.stackStyle}>
            <Input
              readonly
              value={user?.name}
              size="small"
              name="firstName"
              label="First Name"
            />
            <Input
              readonly
              value={user?.surname}
              name="lastName"
              size="small"
              label="Last Name"
            />
            <Input
              readonly
              value={user?.email}
              name="email"
              size="small"
              label="Email"
            />
          </Stack>
        </Box>
        <Box sx={sxStyles.modalColumnHeadingBox}>
          <ModalColumnHeading>Access</ModalColumnHeading>
          <Box sx={sxStyles.userDetailsBox}>
            {user?.company_roles?.map((company) => {
              return (
                <Box key={company?.company_id} sx={sxStyles.innerBox}>
                  <Input
                    readonly
                    name="firstName"
                    size="small"
                    value={company?.company_name}
                    label="Site"
                  />
                  <Input
                    readonly
                    name="lastName"
                    size="small"
                    value={company?.role_name}
                    label="Role"
                  />
                  <Divider sx={sxStyles.dividerStyle} />
                </Box>
              )
            })}
          </Box>
        </Box>
      </Box>
    </Modal>,
    toggleModal,
  ]
}

export default useUserInfoModal
